import { Typography } from "@lyfegen-platform/react-common";
import { Collapse, Divider, IconButton, Link, useTheme } from "@material-ui/core";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import { LiteBox } from "../../../../../components/lite/LiteBox";
import { useState } from "react";
import { useHistory } from "react-router";

interface IDomainDividerProps {
	title: string;
	globalDomainId?: string;
	addProductDomainButton?: () => JSX.Element;
	content?: JSX.Element;
	counterSection?: JSX.Element;
}

export const DomainDivider = (props: IDomainDividerProps) => {
	const { title, content, addProductDomainButton, globalDomainId, counterSection } = props;
	const { push } = useHistory();
	const [open, setOpen] = useState(!!content);
	const {
		palette: {
			widgetHeaderText: { main },
		},
		typography: { pxToRem },
	} = useTheme();

	const handleClick = () => {
		setOpen(!open);
	};

	const handleDomainClick = (e: React.SyntheticEvent) => {
		if (!globalDomainId) {
			return;
		}

		e.preventDefault();
		push(`/organization-settings/domains/${globalDomainId}`);
	};

	return (
		<LiteBox>
			<LiteBox width="100%" display="flex">
				{/* GLOBAL DOMAIN ACCESS (LEVEL 0) */}
				{globalDomainId && (
					<LiteBox width="100%" display="flex" justifyContent="space-between" alignItems="center">
						{!!content && (
							<IconButton color="inherit" size="small" onClick={handleClick}>
								{open ? <ArrowDropUp /> : <ArrowDropDown />}
							</IconButton>
						)}
						<Link underline="none" onClick={handleDomainClick}>
							<Typography type="h7" color="primary" style={{ cursor: "pointer", textTransform: "none" }}>
								{title}
							</Typography>
						</Link>
						<Divider style={{ flexGrow: 1, margin: pxToRem(15), backgroundColor: main }} />
						{!!addProductDomainButton && addProductDomainButton()}
					</LiteBox>
				)}
			</LiteBox>
			{counterSection}
			<Collapse in={open}>{content}</Collapse>
		</LiteBox>
	);
};
